import * as yup from "yup";

export const latLngSchema = yup.object({
	lat: yup.number().required(),
	lng: yup.number().required()
});

export type LatLng = yup.Asserts<typeof latLngSchema>;
